// src/lib/uebersetzungen/hr-ui.js
// Kroatische Oberflaechen-Texte. Schluessel = deutscher Text (siehe lib/sprache.js).
// Zwei Teile, damit die Uebersetzung in kleinen Stuecken entstehen konnte.
import { UI_HR_TEIL1 } from './hr-ui-teil1';
import { UI_HR_TEIL2 } from './hr-ui-teil2';

export const UI_HR = { ...UI_HR_TEIL1, ...UI_HR_TEIL2 };
